
import { toNumber } from 'lodash'

export default {

  /**
   * Helper method that calls the appropriate specific conversion function
   *
   * @param Float measurement
   * @param String fromScale 'c' or 'f'
   * @param String toScale 'c' or 'f'
   * @return Float
   */
  to: function (measurement, fromScale, toScale) {
    fromScale = fromScale.toLowerCase()
    toScale = toScale.toLowerCase()

    if (fromScale === toScale) {
      return measurement
    }

    if (fromScale === 'f' && toScale === 'c') {
      return this.fahrenheitToCelsius(measurement)
    }

    if (fromScale === 'c' && toScale === 'f') {
      return this.celsiusToFahrenheit(measurement)
    }

    throw new Error('Unsupported temperature scale')
  },

  /**
   * Converts the measurement from fahrenheit to celsius
   *
   * @param Float measurement
   * @return Float
   */
  fahrenheitToCelsius: function (measurement) {
    return (measurement - 32) * 5 / 9
  },

  /**
   * Converts the measurement from celsius to fahrenheit
   *
   * @param Float measurement
   * @return Float
   */
  celsiusToFahrenheit: function (measurement) {
    return (measurement * 9 / 5) + 32
  },

  /**
   * Format a temperature according to the specified precision.
   * @param temperature
   * @param precision
   * @returns {string}
   */
  formatTemperature (temperature, precision = 1) {
    if (temperature != null) {
      temperature = toNumber(temperature)
      const roundedTemperature = (Math.round(temperature * 10) / 10)
      if (!isNaN(roundedTemperature)) {
        return roundedTemperature.toFixed(precision)
      }
    }
  }

}
